import React, { createContext, useContext, Suspense } from "react";
import { BROKERS, EXCHANGES } from "src/context/constants";
import { useExchange } from "src/hooks";

//context provider ...
type ContextProps = {
  open: boolean;
  handleClose: () => void;
  handleSwitch: () => void;
  openForgot?: () => void;
};

//context provider ...
const LoginPopupContext = createContext<Partial<ContextProps>>({});

//context provider ...
export const useLoginPopupContext = () => {
  return useContext(LoginPopupContext);
};
interface LoginPopUpInterface {
  open: boolean;
  handleClose: any;
  handleSwitch: any;
  openForgot?: () => void;
}

const LoginPopUp: React.FC<LoginPopUpInterface> = ({
  open,
  handleClose,
  handleSwitch,
  openForgot,
}) => {
  const exchange = useExchange();

  const tableOverviewStore: ContextProps = {
    open: open,
    handleClose: handleClose,
    handleSwitch: handleSwitch,
    openForgot: openForgot,
  };

  const loginPopupManager = () => {
    switch (exchange) {
      case EXCHANGES.settrade:
        return React.lazy(() => import("./settrade"));
      case EXCHANGES.bitkub:
        return React.lazy(() => import("./bitkub"));
      default:
        return React.lazy(() => import("./settrade"));
    }
  };

  const LoginMultiBrokerPopup = loginPopupManager();

  return (
    <React.Fragment>
      <LoginPopupContext.Provider value={tableOverviewStore}>
        <Suspense fallback={<div></div>}>
          <LoginMultiBrokerPopup />
        </Suspense>
      </LoginPopupContext.Provider>
    </React.Fragment>
  );
};

export default LoginPopUp;
